// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Alert, Paper, Stack, Text } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import type { JSX } from 'react';
import { useState } from 'react';
import { type SweRow, useSweList } from './hooks/useSweList';
import { SwePatientList } from './SwePatientList';

export function SweListTab(): JSX.Element {
  const { rows, loading, error } = useSweList();
  const [selectedSweId, setSelectedSweId] = useState<string | undefined>();
  const selectedSwe = rows.find((r) => r.id === selectedSweId);

  return (
    <Stack gap="md">
      {error && (
        <Alert color="red" title="Could not load SWE list">
          {error}
        </Alert>
      )}

      <Paper withBorder p="lg" radius="md" shadow="sm">
        <Stack gap="md">
          <Text fw={500} size="sm">
            Software Engineers ({rows.length})
          </Text>
          {rows.length === 0 ? (
            <Text c="dimmed" size="sm">
              No Software Engineers found
            </Text>
          ) : (
            <DataTable
              fetching={loading}
              minHeight={200}
              records={rows}
              idAccessor={(row) => row.id}
              striped
              highlightOnHover
              fz="sm"
              onRowClick={({ record }) => {
                setSelectedSweId(record.id);
              }}
              columns={[
                {
                  accessor: 'name',
                  title: 'Name',
                },
                {
                  accessor: 'email',
                  title: 'Email',
                },
              ]}
            />
          )}
        </Stack>
      </Paper>

      {selectedSwe && (
        <Paper data-testid="swe-patient-detail" withBorder p="lg" radius="md" shadow="sm">
          <SwePatientList sweId={selectedSwe.id} sweName={selectedSwe.name} />
        </Paper>
      )}
    </Stack>
  );
}
